import { defineStore } from 'pinia';
import { ref, onMounted } from '@nuxtjs/composition-api';
import { useApi } from '~/composables/useApi';
import gethomeBannerSection  from '~/components/HomePage/homeBannerSection.gql'

type homeBannerSection = {
  sliders: {},
};
export const useHomeBannerData = defineStore('homeBannerSection', () => {
  const { query } = useApi();
  const sliders = ref<any | null>(null);
  const loading = ref(false);
  const error = ref<any | null>(null);

  const load = async () => {
    loading.value = true;
    error.value = null;
    try {
      const response = await query<homeBannerSection>(gethomeBannerSection);
      sliders.value = response.data;
    } catch (e) {
      error.value = e;
      throw e;
    } finally {
      loading.value = false;
    }
  };

  onMounted(() => {
    if (!sliders.value) {
      // Fire and forget for client-side; SSR can call load() explicitly if needed
      // no-await-in-onMounted
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      load();
    }
  });

  return {
    sliders,
    loading,
    error,
    load,
  };
});